import React, { useEffect, useMemo, useRef, useState } from "react";
import { DocRequestForm } from "../../pages/DocRequestForm/DocRequestForm";
import { useAuth } from "../../context/AuthContext";
import { BiUpload } from "react-icons/bi";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { storage } from "../../utils/firebase";
import { useToast } from "../../context/ToastContext";
import { uploadPendingAddDoc } from "../../services/api/AddDocApi";
import { useLocation, useNavigate } from "react-router-dom";
import { useBubbleSettings } from "../../context/BubbleSettingsContext";
import { updateUnseenNotification } from "../../services/api/NotificationsApi";
import { uploadFileWithProgress } from "../../utils/ftpUploadUtils";

export const RenderAdditionalDocs = ({ additonaldocs, selectedCourtType, courtRef, refreshDocs }) => {
    const { company } = useAuth()
    const [showModal, setShowModal] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [file, setDocFile] = useState(null);
    const [addedCourtRef, setAddedCourtRef] = useState(null);
    const { showToast } = useToast();
    const { role } = useAuth();
    const [documentUrl, setDocumentUrl] = useState('');
    const [documentID, setDocumentID] = useState(null);
    const addedDocfileInputRef = useRef(null);

    const [uploadingMap, setUploadingMap] = useState({});
    const [uploadProgressMap, setUploadProgressMap] = useState({});
    const [fileMap, setFileMap] = useState({});
    const [documentUrlMap, setDocumentUrlMap] = useState({});
    const [expandedDescriptions, setExpandedDescriptions] = useState({});

    const navigate = useNavigate();
    const location = useLocation();

    const courtref = location.pathname.split('/')[4];

    // Helper function to truncate text by word count
    const truncateText = (text, wordLimit = 40) => {
        if (!text) return "";
        const words = text.split(/\s+/);
        if (words.length <= wordLimit) return text;
        return words.slice(0, wordLimit).join(" ");
    };

    // Helper function to get word count
    const getWordCount = (text) => {
        if (!text) return 0;
        return text.split(/\s+/).filter(word => word.length > 0).length;
    };

    // Toggle description expansion
    const toggleDescription = (docId, e) => {
        e.stopPropagation();
        setExpandedDescriptions(prev => ({
            ...prev,
            [docId]: !prev[docId]
        }));
    };


    useEffect(() => {
        if (additonaldocs.length > 0) {
            setAddedCourtRef(additonaldocs[additonaldocs.length - 1].courtRef);
        }
    }, [additonaldocs]);


    console.log(additonaldocs, "additonaldocs")



    const handleCancelUpload = () => {
        setDocFile(null);
        setDocumentUrl("");
        setUploadProgress(0);
        setUploading(false);
    };

    useEffect(() => {
        if (documentUrl) {
            console.log("documentUrl has been updated (from useEffect):", documentUrl);
        }
    }, [documentUrl]);

    const handleFileChange = (e, docId) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            setFileMap((prev) => ({ ...prev, [docId]: selectedFile }));
            handleFileUpload(selectedFile, docId);
        }
    };

    const handleFileUpload = async (selectedFile, docId) => {
        if (!selectedFile) return;

        setUploadingMap((prev) => ({ ...prev, [docId]: true }));
        setUploadProgressMap((prev) => ({ ...prev, [docId]: 0 }));

        try {
            // Generate file path similar to TaskForm
            const filePath = company._id ? `/${company._id}/others` : `/unknown`;

            await uploadFileWithProgress(
                selectedFile,
                filePath,
                // Progress callback
                (progress) => {
                    setUploadProgressMap((prev) => ({ ...prev, [docId]: progress }));
                },
                // Success callback
                (result) => {
                    console.log('File uploaded successfully:', result);
                    // Use the imageUrl from the utility function (this is what gets saved)
                    setDocumentUrlMap((prev) => ({ ...prev, [docId]: result.imageUrl }));
                    setUploadingMap((prev) => ({ ...prev, [docId]: false }));
                    showToast("File uploaded successfully!", "success");
                },
                // Error callback
                (error) => {
                    console.error("File upload failed:", error);
                    setUploadingMap((prev) => ({ ...prev, [docId]: false }));
                    setUploadProgressMap((prev) => ({ ...prev, [docId]: 0 }));
                    showToast(error.message || "File upload failed!", "error");
                }
            );

        } catch (error) {
            console.error("File upload failed:", error);
            setUploadingMap((prev) => ({ ...prev, [docId]: false }));
            setUploadProgressMap((prev) => ({ ...prev, [docId]: 0 }));
            showToast(error.message || "File upload failed!", "error");
        }
    };
    const handleUploadClick = () => {
        addedDocfileInputRef?.current?.click();
    };

    const handleSubmit = async (docId, url) => {
        if (url && docId) {
            const payload = { url };
            try {
                await uploadPendingAddDoc(payload, docId);
                showToast("Document URL submitted successfully!", "success");
                if (typeof refreshDocs === "function") {
                    refreshDocs();
                }
            } catch (err) {
                console.error("Error submitting document URL:", err);
                showToast("Failed to submit document URL!", "error");
            }
        }
    };
    const { bubbleSettings, fetchAndUpdateBubbleSettings } = useBubbleSettings();
    const documentInfoMap = useMemo(() => {
        const map = {};

        const allCourts = [
            ...(bubbleSettings?.case?.highCourt || []),
            ...(bubbleSettings?.case?.districtCourt || [])
        ];

        allCourts.forEach(entry => {
            (entry.document || []).forEach(doc => {
                if (doc.source) {
                    map[doc.source] = {
                        action: doc.action,
                        notificationId: doc.id
                    };
                }
            });
        });

        return map;
    }, [bubbleSettings]);


    const handleDocClick = async (docId) => {
        const info = documentInfoMap[docId];
        if (info?.notificationId) {
            try {
                await updateUnseenNotification(info.notificationId);
                await fetchAndUpdateBubbleSettings();
            } catch (err) {
                console.error("Error updating notification:", err);
            }
        }
        navigate(`/home/cases/casedetails/${courtref}/additonaldoc/${docId}`);
    };


    return (
        <div className="tab-content">
            {role !== 'customer' && (
                <div className="summary">
                    <div className="tab-add">
                        <button onClick={() => setShowModal(true)}>Add Request For Doc</button>
                    </div>
                </div>
            )}

            {additonaldocs.length === 0 ? (
                <div className="no-data-container">
                    <h3 className="no-data-title">No Additional Documents</h3>
                    <p className="no-data-message">
                        No additional documents have been requested for this case yet.
                    </p>
                </div>
            ) : (
                additonaldocs.map((doc, index) => (
                    <div key={index} className="order-card-doc additional-doc-cards" onClick={() => handleDocClick(doc._id)}>
                        {documentInfoMap[doc._id]?.action && (
                            <span className="doc-status-badge">
                                {documentInfoMap[doc._id].action === "Document Uploaded" ? "Uploaded" : "Requested"}
                            </span>
                        )}


                        <div className="doc-div-detail">
                            <div>
                                <p><strong>Court Ref:</strong> {doc.courtRef}</p>
                                <p><strong>Name:</strong> {doc.name}</p>
                                <p><strong>Status:</strong> {doc.status === "Requested" ? "Pending" : doc.status}</p>
                            </div>
                            <div>
                                <p><strong>Created At:</strong> {new Date(doc.createdAt).toLocaleString()}</p>
                                <p style={{ 
                                    paddingRight: "20px",
                                    wordBreak: "break-word",
                                    maxWidth: "100%"
                                }}>
                                    <strong>Description:</strong>{" "}
                                    {expandedDescriptions[doc._id]
                                        ? doc.description
                                        : getWordCount(doc.description) > 40
                                        ? (
                                            <>
                                                {truncateText(doc.description, 40)}...{" "}
                                                <button
                                                    onClick={(e) => toggleDescription(doc._id, e)}
                                                    style={{
                                                        padding: "2px 8px",
                                                        fontSize: "12px",
                                                        border: "1px solid #ddd",
                                                        borderRadius: "4px",
                                                        backgroundColor: "#f5f5f5",
                                                        cursor: "pointer",
                                                        color: "#333",
                                                        whiteSpace: "nowrap",
                                                    }}
                                                >
                                                    Show More
                                                </button>
                                            </>
                                        )
                                        : doc.description}
                                    {expandedDescriptions[doc._id] && getWordCount(doc.description) > 40 && (
                                        <>
                                            {" "}
                                            <button
                                                onClick={(e) => toggleDescription(doc._id, e)}
                                                style={{
                                                    padding: "2px 8px",
                                                    fontSize: "12px",
                                                    border: "1px solid #ddd",
                                                    borderRadius: "4px",
                                                    backgroundColor: "#f5f5f5",
                                                    cursor: "pointer",
                                                    color: "#333",
                                                    whiteSpace: "nowrap",
                                                }}
                                            >
                                                Show Less
                                            </button>
                                        </>
                                    )}
                                </p>
                            </div>
                        </div>
                        <div className="tab-add">
                            {doc.status === "Uploaded" && doc.url && (
                                <a href={`${process.env.REACT_APP_BACKEND_MAIN_URL_PATH}ftp/view/${doc.url}`} target="_blank" rel="noopener noreferrer">
                                    <button className="view-doc-cases">View Document</button>
                                </a>
                            )}
                        </div>


                        {role === 'customer' && doc.status === "Requested" && (
                            <div className="added-docs-task-upload-group">
                                <div className="added-docs-task-upload-section">
                                    <label className='added-docs-task-upload-label'>Upload Document</label>
                                    <div
                                        className="added-docs-task-upload-click-area"
                                        onClick={(e) => {
                                            e.stopPropagation(); // ✨ prevent bubbling to parent
                                            handleUploadClick();
                                        }}
                                        role="button"
                                        tabIndex={0}
                                        onKeyPress={(e) => {
                                            if (e.key === 'Enter') {
                                                e.stopPropagation(); // also stop propagation here
                                                handleUploadClick();
                                            }
                                        }}
                                    >

                                        <input
                                            id={`file-input-${doc._id}`}
                                            type="file"
                                            onChange={(e) => handleFileChange(e, doc._id)}
                                            style={{ display: "none" }}
                                        />

                                        <div className="added-docs-task-upload-icon">
                                            <BiUpload size={24} color="#0066cc" />
                                            <span>Click to upload</span>
                                        </div>
                                    </div>

                                    {uploadingMap[doc._id] && (
                                        <div className="added-docs-task-upload-progress">
                                            <div className="added-docs-task-upload-progress-bar">
                                                <div
                                                    className="added-docs-task-upload-progress-indicator"
                                                    style={{ width: `${uploadProgressMap[doc._id] || 0}%` }}
                                                />
                                            </div>
                                            <span>{Math.round(uploadProgressMap[doc._id] || 0)}% uploaded</span>
                                        </div>
                                    )}

                                    {documentUrlMap[doc._id] && !uploadingMap[doc._id] && (
                                        <div className="added-docs-task-uploaded-file">
                                            <a
                                                href={`${process.env.REACT_APP_BACKEND_MAIN_URL_PATH}ftp/view/${documentUrlMap[doc._id]}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {fileMap[doc._id] ? fileMap[doc._id].name : "View Uploaded Document"}
                                            </a>
                                            <div className="act-upload-btns">
                                                <button
                                                    type="button"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setFileMap((prev) => ({ ...prev, [doc._id]: null }));
                                                        setDocumentUrlMap((prev) => ({ ...prev, [doc._id]: "" }));
                                                        setUploadProgressMap((prev) => ({ ...prev, [doc._id]: 0 }));
                                                        setUploadingMap((prev) => ({ ...prev, [doc._id]: false }));
                                                    }}
                                                    className="added-docs-task-upload-cancel-button"
                                                >
                                                    Delete Document
                                                </button>
                                                <button
                                                    type="button"
                                                    onClick={(e) => { e.stopPropagation(); handleSubmit(doc._id, documentUrlMap[doc._id]) }}
                                                    className="added-docs-task-upload-submit-button "
                                                >
                                                    Submit Document
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                    <div className="added-docs-task-upload-button-container">
                                        <button onClick={(e) => {
                                            e.stopPropagation();
                                            document.getElementById(`file-input-${doc._id}`).click();
                                        }} className="upload-btn-add-docs">Upload Document</button>
                                    </div>

                                </div>
                            </div>
                        )}
                    </div>
                ))
            )}

            {showModal && (
                <div className="modal-backdrop">
                    <div className="modal">
                        <DocRequestForm
                            initialData={{ addedCourtRef }}
                            selectedCourtType={selectedCourtType}
                            onSuccess={async (courtRef) => {
                                setShowModal(false);
                                if (typeof refreshDocs === "function") {
                                    await refreshDocs();
                                } else {
                                    console.warn("refreshDocs is not a function");
                                }
                                showToast("Document request submitted successfully!", "success"); // ✅ show toast
                            }}
                            onCancel={() => setShowModal(false)}
                            isModal={true}
                        />

                    </div>
                </div>
            )}
        </div>
    );
};
